import { useDraftReallocationState } from "features/capital-activity/event/useHasDraftReallocation";
import { capitalCallReallocationReviewRoute } from "features/capital-call/CapitalCallPage";
import { useTranslation } from "react-i18next";
import Alert from "shared/components/alert/Alert";

export const DraftReallocationAlert: React.FC<{
  fundFamilyId: string;
  fundFamilyEventId: string;
  reallocationFundFamilyEventId?: string;
}> = ({ fundFamilyId, fundFamilyEventId, reallocationFundFamilyEventId }) => {
  const { t } = useTranslation(["common", "capitalActivity"]);
  const {
    hasDraftAllocation,
    existingReallocationEventId,
    deleteReallocationEvent,
  } = useDraftReallocationState({
    fundFamilyId,
    fundFamilyEventId,
  });

  return !reallocationFundFamilyEventId && hasDraftAllocation ? (
    <Alert
      description={t("capitalActivity:reallocation.title")}
      status="info"
      mb="16px"
      primaryAction={{
        title: t("capitalActivity:reallocation.continueDraftReallocation"),
        to: capitalCallReallocationReviewRoute({
          fundFamilyId,
          fundFamilyEventId,
          reallocationFundFamilyEventId: existingReallocationEventId,
        }),
      }}
      secondaryAction={{
        title: t("common:discard"),
        onClick: async () => await deleteReallocationEvent(),
      }}
    />
  ) : undefined;
};
